import React, { ButtonHTMLAttributes } from 'react';
import './Button.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  isLoading?: boolean;
}

/**
 * Reusable Button component
 *
 * @param variant - Button style variant (primary, secondary, danger, ghost)
 * @param size - Button size (small, medium, large)
 * @param fullWidth - If true, button takes full width of container
 * @param isLoading - If true, shows loading state and disables button
 * @param ...props - All standard HTML button attributes
 */
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  isLoading = false,
  className = '',
  children,
  disabled,
  ...props
}) => {
  return (
    <button
      className={`btn btn-${variant} btn-${size} ${fullWidth ? 'btn-full-width' : ''} ${
        isLoading ? 'btn-loading' : ''
      } ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <span className="btn-spinner" />
          <span className="btn-loading-text">{children}</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
